module.exports = __webpack_public_path__ + "static/banner.fc646229.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/css/images/banner.jpg
// module id = ./src/css/images/banner.jpg
// module chunks = 7489246917808536000